import { HttpClient } from "@angular/common/http";
import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnChanges,
  OnInit,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { MatTable } from "@angular/material/table";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { environment } from "@environments/environment";
import { faTrash } from "@fortawesome/pro-solid-svg-icons";

import {
  CdkDragDrop,
  moveItemInArray,
  CdkDragHandle,
} from "@angular/cdk/drag-drop";
import { faGripDotsVertical } from "@fortawesome/pro-light-svg-icons";
const USER_DATA: any[] = [];

const COLUMNS_SCHEMA_TABLE = [
  {
    key: "value",
    type: "value",
    label: " ",
    required: false,
    width: 0,
  },
  {
    key: "form",
    type: "form",
    label: " ",
    required: false,
    width: 800,
  },
  {
    key: "color",
    type: "color",
    label: "Choose Color",
    required: true,
    width: 100,
  },
  {
    key: "isEdit",
    type: "isEdit",
    label: "",
    required: false,
    width: 50,
  },
];

interface PeriodicElement {
  name: string;
  position: number;
  weight: number;
  symbol: string;
  quantity: number;
}

@Component({
    selector: "app-configure-thresholds-table",
    templateUrl: "./configure-thresholds-table.component.html",
    styleUrls: ["./configure-thresholds-table.component.scss"],
    standalone: false
})
export class ConfigureThresholdsTableComponent implements OnInit, OnChanges {
  public editForm!: UntypedFormGroup;
  field: any;
  auto: any;
  fieldData: any;
  fieldColorData: any;
  fieldsHidden: boolean = false;
  message: string = "Are you sure?";
  private dataPointId!: number;
  name: string = "";
  type: string = "";
  typeEnding: string = "";
  typeBeginning: string = "";
  expressionName: string = "";
  public formFields: any[] = [];
  public displayRules: any;
  public filteredDisplayRules: any[] = [];
  public fieldConfig: any;
  public loading: boolean = true;
  dragDisabled = true;
  faGripDotsVertical = faGripDotsVertical;
  dataSource = USER_DATA;
  noLimitColor: any;

  columnsSchema: any = COLUMNS_SCHEMA_TABLE;
  displayedColumns: string[] = COLUMNS_SCHEMA_TABLE.map((col) => col.key);

  faTrash = faTrash;
  emptyVal: any;
  chartType: any;
  public error: boolean = false;

  @ViewChild("target") private myScrollContainer!: ElementRef;
  @ViewChild("table", { static: true }) table!: MatTable<PeriodicElement>;

  constructor(
    private fb: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private http: HttpClient,
    private cdRef: ChangeDetectorRef,
    private dialogRef: MatDialogRef<ConfigureThresholdsTableComponent>
  ) {
    if (data) {
      this.message = data.message || this.message;
      this.dataPointId = data.id;
      this.fieldData = data.field;
      if (data.field && data.field.dynamicChartColors)
        this.fieldColorData = data.field.dynamicChartColors;
      this.auto = data.auto;
      this.chartType = data.chartType;
      if (this.fieldData && this.fieldData.name)
        this.name = this.fieldData.name;
    }
  }

  drop(event: any) {
    // Return the drag container to disabled.
    this.dragDisabled = true;

    const previousIndex = this.dataSource.findIndex(
      (d) => d === event.item.data
    );
    moveItemInArray(this.dataSource, previousIndex, event.currentIndex);
    this.table.renderRows();
  }

  rowFormContents(row: any) {
    this.dataSource[row.id].form = row.form;
  }

  generateRowFieldData(fieldSet: any) {
    const data: any = [];
    let item = {};
    const field = this.fieldConfig.data;
    Object.keys(fieldSet.controls).forEach((key, index) => {
      if (fieldSet.controls[key].value) {
        item = { name: key, value: fieldSet.controls[key].value };
        if (
          field.filters.data[index].displayType == "toggle" ||
          field.filters.data[index].displayType == "button-toggle" ||
          field.filters.data[index].displayType == "checkbox"
        ) {
          field.filters.data[index].value = fieldSet
            .get(key)!
            .get("item")!.value;
        } else {
          if (field.filters.data[index].displayType == "number")
            field.filters.data[index].value = parseInt(
              fieldSet.get(key)!.value
            );
          else field.filters.data[index].value = fieldSet.get(key)!.value;
        }
        data.push(item);
      }
    });

    let fieldDate: any[] = [];
    field.filters.data.forEach((element: any) => {
      const item = {
        id: element.id,
        name: element.name,
        value: element.value,
      };

      if (fieldSet.controls[element.name].pristine) {
      } else fieldDate.push(item);
    });

    return fieldDate;
  }

  scrollToBottom(): void {
    try {
      this.myScrollContainer.nativeElement.scrollTop =
        this.myScrollContainer.nativeElement.scrollHeight;
    } catch (err) {}
  }

  addRow(rowdata?: any) {
    let newRow = {};
    if (rowdata) {
      newRow = {
        id: Math.floor(Math.random() * Math.floor(Math.random() * Date.now())),
        color: rowdata.color,
        value: rowdata.value,
        form: rowdata.form,
        isEdit: true,
      };
    } else {
      newRow = {
        id: Math.floor(Math.random() * Math.floor(Math.random() * Date.now())),
        value: "",
        form: "",
        color: "",
        isEdit: true,
      };
    }
    this.dataSource = [...this.dataSource, newRow];
    setTimeout(() => {
      this.scrollToBottom();
    }, 100);
  }

  removeRow(id: any) {
    this.dataSource = this.dataSource.filter((u) => u.id !== id);
  }

  onChange(event: any, element: any) {}

  validateForm() {
    let disabled = true;
    let validRow = true;

    this.dataSource.forEach((row: any) => {
      validRow = validRow && this.validateRow(row);
    });

    disabled = disabled && !validRow;

    return disabled;
  }
  getPlaceholder(row: any) {
    let placeholder = "Enter Value";
    // if (this.dataSource.length == row) placeholder = "Leave blank for no limit";
    return placeholder;
  }
  validateStructure() {
    const data: any = {};
    data.items = [];

    this.dataSource.forEach((row: any) => {
      const datarow: any = {};
      const rowFieldData = this.generateRowFieldData(row.form);
      datarow.dataPointId = this.dataPointId;
      datarow.value = rowFieldData;
      datarow.color = row.color;
      //dynamically choosing colors for text based on the background color chosen
      datarow.textColor = this.pickTextColorBasedOnBgColorSimple(
        row.color,
        "#FFFFFF",
        "#000000"
      );

      data.items.push(datarow);
    });

    this.error = false;
    var valueArr = data.items.map(function (item: any) {
      const temp = JSON.stringify(item.value);
      return temp;
    });

    var isDuplicate = valueArr.some(function (item: any, idx: any) {
      return valueArr.indexOf(item) != idx;
    });
  }

  validateRow(row: any) {
    let validRow = true;

    if (row.color == "") {
      validRow = false;
    } else {
      if (!row.value)
        if (row.form)
          if (!row.form.valid) {
            validRow = false;
          }
    }
    return validRow;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onConfirmClick(): void {
    const data: any = {};
    data.items = [];

    this.dataSource.forEach((row: any) => {
      const datarow: any = {};
      const rowFieldData = this.generateRowFieldData(row.form);
      datarow.dataPointId = this.dataPointId;
      datarow.value = rowFieldData;
      datarow.color = row.color;
      //dynamically choosing colors for text based on the background color chosen
      datarow.textColor = this.pickTextColorBasedOnBgColorSimple(
        row.color,
        "#FFFFFF",
        "#000000"
      );

      data.items.push(datarow);
    });

    this.error = false;
    var valueArr = data.items.map(function (item: any) {
      const temp = JSON.stringify(item.value);
      return temp;
    });

    var isDuplicate = valueArr.some(function (item: any, idx: any) {
      return valueArr.indexOf(item) != idx;
    });

    if (!isDuplicate) {
      this.dialogRef.close(data);
    } else {
      this.error = true;
    }
  }

  pickTextColorBasedOnBgColorSimple(
    bgColor: string,
    lightColor: string,
    darkColor: string
  ) {
    var color = bgColor.charAt(0) === "#" ? bgColor.substring(1, 7) : bgColor;
    var r = parseInt(color.substring(0, 2), 16); // hexToR
    var g = parseInt(color.substring(2, 4), 16); // hexToG
    var b = parseInt(color.substring(4, 6), 16); // hexToB
    return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? darkColor : lightColor;
  }

  onCancelClick(): void {
    this.dialogRef.close(null);
  }

  ngOnChanges() {
    this.cdRef.markForCheck();
    this.cdRef.detectChanges();
  }

  loadDataPointRow(row?: any) {
    if (row) this.addRow(row);
    else this.addRow();
  }

  getConfiguration() {
    this.http
      .get(
        environment.enterpriseUrls.apiEndpoint +
          "/datapoints/" +
          this.dataPointId +
          "?include=filters,displayRules"
      )
      .subscribe((suc: any) => {
        this.fieldConfig = suc;
        this.displayRules = suc.data.displayRules.data;
        this.loading = false;

        if (this.fieldColorData) {
          this.fieldColorData.forEach((row: any) => {
            this.loadDataPointRow(row);
          });
        } else {
          this.loadDataPointRow();
        }
      });
  }
  ngOnInit(): void {
    this.editForm = this.fb.group({});
    this.getConfiguration();
  }
}
